<template>
    <div v-if="active" class="fixed z-10 bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
        <div class="fixed inset-0 transition-opacity" @click="cancel()">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <div id="modal" class="rounded-sm px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div>
                <div class="mt-3 sm:mt-5 text-left">
                    <h3 class="modal-title text-2xl leading-6 font-medium" id="modal-headline">
                        {{$t('translations.components.modal-boarding-pass.title')}}
                    </h3>
                    <div class="mt-2">
                        <p class="text-base leading-5">
                            {{$t('translations.components.modal-boarding-pass.instruction')}}
                        </p>
                    </div>
                    <div class="mt-4">
                        <input ref="input"
                               v-model="value"
                               @keyup.enter="confirm()"
                               type="text"
                               class="form-input w-full text-lg"
                               :placeholder="$t('translations.components.modal-boarding-pass.placeholder')" />
                    </div>
                </div>
            </div>
            <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <span class="flex w-full rounded-sm shadow-sm sm:col-start-2">
                    <a @click="confirm()" :class="{'opacity-50 pointer-events-none': !value.trim()}" class="button button-large button-sjefgreen w-full">
                        {{$t('translations.components.modal-boarding-pass.confirm')}}
                    </a>
                </span>
                <span class="mt-3 flex w-full rounded-sm shadow-sm sm:mt-0 sm:col-start-1">
                    <a @click="cancel()" class="button button-large button-danger w-full">
                        {{$t('translations.components.modal-boarding-pass.cancel')}}
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import BarcodeReader from '../mixins/barcode.reader.js';

// shortest plausible boarding pass; guards against stray/partial scans
const MIN_LENGTH = 4;
// IATA BCBP barcodes start with the format code M followed by the leg count
const BCBP_PATTERN = /^M\d/;

export default {
    name: 'ModalBoardingPass',
    mixins: [BarcodeReader],
    data () {
        return {
            active: false,
            value: '',
        }
    },
    methods: {
        open() {
            this.value = ''
            this.active = true
            // suppress the item barcode scanner while this dialog captures input
            this.$store.dispatch('terminal/setModalActive', true)
            this.$nextTick(() => {
                if (this.$refs.input) {
                    this.$refs.input.focus()
                }
            })
        },
        close() {
            this.active = false
            this.$store.dispatch('terminal/setModalActive', false)
        },
        // called by the barcode.reader mixin on a completed scan
        barcodeScanned(barcode) {
            if (!this.active) {
                return
            }
            this.submit(barcode, true)
        },
        confirm() {
            this.submit(this.value, false)
        },
        submit(raw, fromScan) {
            let boardingPass = (raw || '').trim()
            if (!boardingPass) {
                return
            }

            // hard guard (format-agnostic): reject stray/partial input
            if (boardingPass.length < MIN_LENGTH) {
                this.$notify({
                    group: "notifications",
                    type: 'error',
                    title: this.$t('translations.components.modal-boarding-pass.invalid-title'),
                    text: this.$t('translations.components.modal-boarding-pass.invalid-text'),
                }, 2000)
                return
            }

            // soft check: warn (but still accept) when a scan doesn't look like a boarding pass
            if (fromScan && !BCBP_PATTERN.test(boardingPass)) {
                this.$notify({
                    group: "notifications",
                    type: 'warning',
                    title: this.$t('translations.components.modal-boarding-pass.suspicious-title'),
                    text: this.$t('translations.components.modal-boarding-pass.suspicious-text'),
                }, 2000)
            }

            this.$emit('confirmed', boardingPass)
            this.close()
        },
        cancel() {
            this.$emit('cancel')
            this.close()
        },
    },
}
</script>
